<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" :echart.sync="echart" @contextmenu="contextmenu" />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: Number,
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  data() {
    return {
      init: {
        xAxis: {
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      data: {
        value: null,
      },
      echart: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.data.value = this.value;
      },
    },
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.isDark;
    },
    options() {
      return {
        series: this.series(this.data.value),
      };
    },
  },
  methods: {
    series(value) {
      return [
        {
          color: ['#777777'],
          type: 'liquidFill',
          radius: '100%',
          amplitude: '0%',
          waveAnimation: false,
          shape: 'rect', // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'. Or, an SVG path starting with 'path://'
          center: ['50%', '50%'],
          backgroundStyle: {
            color: this.isDark ? '#242424' : '#f7f7f7',
            borderWidth: 0,
            shadowColor: 'rgba(0, 0, 0, 0.4)',
            shadowBlur: 20,
          },
          outline: {
            show: false,
          },
          label: {
            normal: {
              formatter: param => param.value,
              textStyle: {
                color: this.isDark ? '#ddd' : '#6b717d',
                fontSize: 20,
              },
            },
          },
          data: [
            {
              value: value,
            },
          ],
        },
      ];
    },
  },
};
</script>
